/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable arrow-body-style */
/* eslint-disable max-len */
import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { LedgerService } from 'src/app/services/ledger.service';
import { ShareService } from 'src/app/services/share.service';
import { environment } from 'src/environments/environment';
import { sha256 } from 'js-sha256';
import firebase from 'firebase/app';
import 'firebase/storage';


@Component({
  selector: 'app-ledger',
  templateUrl: './ledger.component.html',
  styleUrls: ['./ledger.component.scss'],
})
export class LedgerComponent implements AfterViewInit {

  unsub1;
  educoins = 0;
  today = new Date();
  tomorrow = new Date(this.today).setDate(this.today.getDate() + 1);
  timeDiff;
  intervel;
  isMining = 0;
  balance = 0;
  lifeTimeEarnings = 0;
  lifeTimeSpent = 0;
  coupon = '';
  navigator = navigator;
  currentUser = this.authService.currentUser;
  viewVideo = false;
  environment = environment;
  pathName = window.location.pathname;
  myVideoList = [];
  video;
  videoListLength;
  count = 0;
  storage = firebase.storage();
  products = [
    { name: 'CASIO FX-991CW Scientific Calculator (12 Digit)', coins: 30000, image: 'assets/products-deliverables/fx-991cw-casio-original-imaghg8ghzzm8ghj.webp' },
    { name: 'Cello Jotdot Ball Pen (Pack of 50, Ink Color - Blue)', coins: 20000, image: 'assets/products-deliverables/jotdot-ball-pen-pack-of-50-blue-cello-original-imag3hgtdg9vnnts.webp' },
    { name: 'Classmate Longbook A4 Notebook Unruled 140 Pages (Multicolor, Pack of 12)', coins: 10000, image: 'assets/products-deliverables/classmate-2000200-original-imafw2qh6fkezugz.webp' },
    { name: 'Pentonic Linc Extra Dark Premium Pencil, Pack of 20 Pencil (Brown Body)', coins: 5000, image: 'assets/products-deliverables/linc-extra-dark-premium-pencil-pack-of-20-pentonic-original-imafhupfkmqzxzym.webp' },
  ];



  constructor(
    public authService: AuthService,
    public ledgerService: LedgerService,
    public shareService: ShareService,
    private router: Router,
    private navController: NavController
  ) {
    this.unsub1 = this.authService.currentAccount.subscribe(async (user) => {
      if (user) {
        this.currentUser = user;
        this.calcBalance(undefined);
      }
    });
    this.unsub1 = this.ledgerService.ledgerUpdate.subscribe(async (ledger) => { this.calcBalance(ledger); });

    if (localStorage.getItem('miningStartTime')) {
      this.startMining();
    }

    this.ledgerService.getVideoList().then((list: any) => {
      this.myVideoList = list;
      this.videoListLength = list.length;
      this.getVideoUrl(this.myVideoList[this.count]);
    });

  }



  ngAfterViewInit() {
    const script = document.createElement('script');
    script.setAttribute('src', 'https://checkout.razorpay.com/v1/payment-button.js');
    script.setAttribute('data-payment_button_id', 'pl_MI0SMIJ54L0zun');
  }

  ionViewDidEnter() {
    const script = document.createElement('script');
    script.setAttribute('src', 'https://checkout.razorpay.com/v1/payment-button.js');
    script.setAttribute('data-payment_button_id', 'pl_MI0SMIJ54L0zun');
  }

  share() {
    this.shareService.share('Join Share Square with my referral and get bonus coins.', 'Referral Link', undefined, `${environment.siteUrl}login?refCode=${this.currentUser.refCode}`);
  }

  calcBalance(ledger) {
    ledger = ledger ? ledger : this.ledgerService.ledger;
    this.balance = ledger?.balance || 0;
    this.lifeTimeEarnings = ledger?.earnings || 0;
    this.lifeTimeSpent = ledger?.spent || 0;
  }

  buyCoins() {
    const request = {
      merchantId: 'M1H52P87BSDG',
      merchantTransactionId: Date.now().toString(),
      merchantUserId: this.currentUser.id,
      amount: 10000,
      callbackUrl: 'https://sharesquare.co.in/payment-success',
      deviceContext: {
        deviceOS: 'WEBSITE'
      },
      paymentInstrument: {
        type: 'UPI_INTENT',
        targetApp: 'com.phonepe.app',
      }
    };
    const encoded = btoa(JSON.stringify(request));
    const final = sha256(encoded + '/pg/v1/pay352949ce-a259-4d37-9135-69cc2d644df8') + '###1';
    console.log(final);

    // const phonePeOptions = {
    //   method: 'POST',
    //   headers: {
    //     accept: 'application/json',
    //     'Content-Type': 'application/json',
    //     'X-VERIFY': final
    //   }
    // };
    // fetch('https://api-preprod.phonepe.com/apis/pg-sandbox/pg/v1/pay', phonePeOptions)
    //   .then(response => response.json())
    //   .then(response => console.log(response))
    //   .catch(err => console.error(err));



    const xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://api-preprod.phonepe.com/apis/pg-sandbox/pg/v1/pay', true);
    xhr.setRequestHeader('accept', 'application/x-www-form-urlencoded');
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhr.setRequestHeader('X-VERIFY', final);
    xhr.onload = (data) => {
      // do something to response
      console.log('--------->>',data);
    };
    xhr.send(JSON.stringify({request:encoded}));
  }

  startMining() {
    if (!localStorage.getItem('miningStartTime')) {
      localStorage.setItem('miningStartTime', new Date().toString());
    }
    this.isMining = 1;
    const futureTime = new Date(localStorage.getItem('miningStartTime'));
    futureTime.setDate(futureTime.getDate() + 1);
    this.intervel = setInterval(() => {
      this.timeDiff = this.timeDiffCalc(futureTime, new Date());
      if (this.checkRewardAvailability(new Date(localStorage.getItem('miningStartTime')))) {
        this.isMining = 2;
        clearInterval(this.intervel);
      }
    }, 1000);
  }

  collectReward() {
    this.ledgerService.addUserLedger({ user: this.currentUser.id, message: 'Your Mining Bonus!', value: 1 });
    localStorage.removeItem('miningStartTime');
    this.isMining = 0;
  }

  waitItsMining() {
    this.authService.presentToast(`Please Wait! ${this.timeDiff} to get your reward of 1 coin!`);
  }
  interested(videoId) {
    this.ledgerService.watchedVideo(videoId);
  }

  checkRewardAvailability(date) {
    if (date) {
      const futureTime = new Date(date);
      futureTime.setDate(futureTime.getDate() + 1);
      if (futureTime < new Date()) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }


  redeemCoupon() {
    this.ledgerService.redeemCoupon(this.coupon);
    this.coupon = '';
  }

  goToShop() {
    this.navController.navigateForward('/shop');
  }


  timeDiffCalc(dateFuture, dateNow) {
    let diffInMilliSeconds = Math.abs(dateFuture - dateNow) / 1000;

    // calculate days
    const days = Math.floor(diffInMilliSeconds / 86400);
    diffInMilliSeconds -= days * 86400;
    // console.log('calculated days', days);

    // calculate hours
    const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
    diffInMilliSeconds -= hours * 3600;
    // console.log('calculated hours', hours);

    // calculate minutes
    const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
    diffInMilliSeconds -= minutes * 60;
    // console.log('minutes', minutes);

    let difference = '';
    if (days > 0) {
      difference += (days === 1) ? `${days} day, ` : `${days} days, `;
    }

    difference += (hours === 0 || hours === 1) ? `${hours} hour, ` : `${hours} hours, `;

    difference += (minutes === 0 || hours === 1) ? `${minutes} minutes` : `${minutes} minutes`;

    return difference;
  }


  async playVideo() {
    this.viewVideo = true;
    console.log(this.viewVideo);
    this.count++;
  }

  vidEnded() {
    this.ledgerService.addUserLedger({ user: this.currentUser.id, message: 'Promo Video Bonus', value: 1 });
    this.viewVideo = false;
    if (this.count < this.videoListLength) {
      this.getVideoUrl(this.myVideoList[this.count]);
    }
    else {
      this.count = 0;
      this.getVideoUrl(this.myVideoList[this.count]);
    }
  }

  ionviewDidLeave() {
    this.unsub1.unsubscribe();
    clearInterval(this.intervel);
  }

  async getVideoUrl(video: any) {
    try {
      const ref = this.storage.ref(video.video);
      const newUrl = await ref.getDownloadURL();
      console.log(newUrl);
      video.video = newUrl;
      this.video = video;
      return newUrl;
    } catch (error) {
      console.error('Error getting video URL:', error);
      return null;
    }
  }

}
